import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportGrossDeltaLinkedMarketFetch } from './actions';

export const sagasReportGrossDeltaLinkedMarket = [
  takeLatest(actionReportGrossDeltaLinkedMarketFetch.rejected, workerErrorNotifyThunk),
];
